











import { Vue, Component, Prop } from "vue-property-decorator";
import NotesCard from '@/NotesCard.vue'
import BoardsCard from '@/BoardsCard.vue'
import BoxCard from '@/BoxCard.vue'
import GraphsAndVisualizationsCard from '@/GraphsAndVisualizationsCard.vue';
import GraphsCard from '@/GraphsCard.vue';
import { Project } from '../../../common/project';

@Component({
  components: {
    NotesCard,
    BoardsCard,
    BoxCard,
    GraphsCard
  }
})
export default class CentralView extends Vue {
  get project() {
    return this.$store.state.currentProject
  }

  show = false;
  lorem = `Lorem ipsum dolor sit amet, mel at clita quando. Te sit oratio vituperatoribus, nam ad ipsum posidonium mediocritatem, explicari dissentiunt cu mea. Repudiare disputationi vim in, mollis iriure nec cu, alienum argumentum ius ad. Pri eu justo aeque torquatos.`

  updated() {
    console.log(`CentralView update ${this.project ? this.project.name : "null"}`);
  }

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CentralView.vue